<div class="row" *ngIf="homePageConfiguration">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-baseline">
      <div>
        <h5 class="mb-0 mt-0" translate>HOME_PAGE_CONFIG_TITLE</h5>
        <span class="font-italic small mb-2 d-inline-block" translate>HOME_PAGE_CONFIG_DESCRIPTION</span>
      </div>


      <button
        class="btn btn-default"
        style="font-size: 20px;"
        (click)="save()"
      >
        <i ngbTooltip="{{'SAVE' | translate}}" class="fas fa-save"></i>
      </button>
    </div>

    @if (!!homePageMatchGroupsEnabled && oldHomePagePathWarnings.length > 0) {
      <div class="alert alert-danger">
        <h5 class="mt-0">{{ 'OLD_HOME_PAGE_PATH_WARNING_TITLE' | translate }}</h5>
        <p class="mb-2">{{ 'OLD_HOME_PAGE_PATH_WARNING_DESCRIPTION' | translate }}</p>

        <div class="d-flex flex-column">
          @for (warning of oldHomePagePathWarnings; track warning.role) {
            <span><b>{{ warning.role | translate }}:</b> {{ warning.path }}</span>
          }
        </div>
      </div>
    }

    @if (!!homePageMatchGroupsEnabled) {
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="icon-column"></th>
            <th class="role-column">
              <strong>{{ 'ROLES' | translate }}</strong>
            </th>
            <th class="group-column">
              <strong>{{ 'GROUPS' | translate }}</strong>
            </th>
            <th class="flow-column">
              <strong>{{ 'GUNG_FLOWS' | translate }}</strong>
            </th>
            <th class="path-column">
              <strong>{{ 'PAGE_PATH' | translate }}</strong>
            </th>
            @if (homepageDateRangeEnabled) {
              <th class="date-column">
                <strong>{{ 'DATE_PERIOD' | translate }}</strong>
              </th>
            }
            <th class="icon-column text-right">
              <gung-button classes="btn-primary btn-sm p-3" label="{{ '' | translate }}" [icon]="'fa-regular fa-plus'" [onClick]="addRow.bind(this)" />
            </th>
          </tr>
        </thead>
        <tbody cdkDropList class="table-list" (cdkDropListDropped)="onDrop($event)" [cdkDropListData]="homePageMatchGroupsTableData">
          <tr *ngFor="let pageMatch of homePageMatchGroupsTableData; index as i" class="matrix-row" [class.row-inactive]="!isRowCurrentlyActive(pageMatch)" cdkDrag>
            <td [colSpan]="homepageDateRangeEnabled ? 7 : 6" class="p-0" *cdkDragPlaceholder>
              <div class="row-ist-placeholder"></div>
            </td>

            <td class="icon-column">
              <i class="fas fa-arrows-alt drag-handle p-2 cursor-grab" cdkDragHandle></i>
            </td>

            <td class="role-column">
              <lib-gung-input-multi-select
                [suppressLabel]="true"
                [optionsList]="pageMatch.userRoleOptions"
                (selectedValues)="setRoleValue($event, i)"
                [ngBootstrapContainer]="'body'"
                [showId]="false"
                [previewField]="'name'"
              />
            </td>

            <td class="group-column">
              <lib-gung-input-multi-select
                [suppressLabel]="true"
                [optionsList]="pageMatch.userGroupOptions"
                (selectedValues)="setGroupValue($event, i)"
                [ngBootstrapContainer]="'body'"
                [showId]="false"
                [previewField]="'name'"
              />
            </td>

            <td class="flow-column">
              <lib-gung-input-multi-select
                [suppressLabel]="true"
                [optionsList]="pageMatch.flowOptions"
                (selectedValues)="setFlowValue($event, i)"
                [ngBootstrapContainer]="'body'"
                [showId]="false"
                [previewField]="'name'"
              />
            </td>

            <td class="path-column">
              <lib-gung-text-input [suppressLabel]="true" [(ngModel)]="pageMatch.pagePath"/>
            </td>

            @if (homepageDateRangeEnabled) {
              <td class="date-column">
                <div class="d-flex align-items-start gap-2">
                  <div class="date-picker-wrapper">
                    <lib-gung-date-picker
                      label="START_DATE"
                      [suppressLabel]="true"
                      [container]="'body'"
                      [currentselectedDate]="pageMatch.startDate || ''"
                      (selectedDate)="setStartDate($event, i)"
                    ></lib-gung-date-picker>
                  </div>
                  <div class="date-picker-wrapper">
                    <lib-gung-date-picker
                      label="END_DATE"
                      [suppressLabel]="true"
                      [container]="'body'"
                      [currentselectedDate]="pageMatch.endDate || ''"
                      (selectedDate)="setEndDate($event, i)"
                    ></lib-gung-date-picker>
                    @if (hasDateRangeError[i]) {
                      <small class="tooltip-error" translate>INVALID_DATE_RANGE</small>
                    }
                  </div>
                  <i
                    class="fa-regular fa-circle-info mt-2"
                    [ngbTooltip]="'DATE_PERIOD_INFO' | translate"
                  ></i>
                </div>
              </td>
            }

            <td class="text-right">
              <i
                (click)="removeRow(i)"
                class="fa-solid fa-trash p-2 cursor-pointer"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    }

    @if (!homePageMatchGroupsEnabled) {
    <div class="d-flex flex-column">
      <div class="d-flex align-items-center mb-2" *ngFor="let role of rolesToShow">
        <div style="width: 150px">
          <lib-gung-text-input
            [suppressLabel]="true"
            [renderStatic]="true"
            [placeholder]="role"
          ></lib-gung-text-input>
        </div>
        <div style="width: 400px;">
          <lib-gung-text-input
            [ngClass]="{ 'is-invalid': hasRoleError[role] }"
            [suppressLabel]="true"
            [(ngModel)]="homePageConfiguration.roleHomePages[role]"
            (ngModelChange)="validateInput($event, role)"
          ></lib-gung-text-input>
        </div>
        <div>
          <i *ngIf="hasRoleError[role]"
             [ngbTooltip]="'HOME_PAGE_LINK_ERROR_TOOLTIP' | translate"
             class="fa-regular fa-circle-exclamation ml-2 tooltip-error"></i>
        </div>
      </div>
    </div>
    }
  </div>
</div>
